"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSources = void 0;
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const utilities_1 = require("../../utilities");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const types_1 = require("./types");
const useSources = _ref => {
  let {
    data,
    chartSources = []
  } = _ref;
  const customSources = (0, lodash_1.default)(chartSources).flatMap(_ref2 => {
    let {
      url = '',
      name = url,
      agencyname = '',
      lastupdated = ''
    } = _ref2;
    return {
      name,
      url,
      agencyname,
      lastupdated
    };
  }).value();
  const sources = (0, lodash_1.default)(data).flatMap(_ref3 => {
    let {
      sources = [],
      metadata = {}
    } = _ref3;
    if (sources) {
      return sources.map(_ref4 => {
        let {
          url,
          name = url,
          agencyname
        } = _ref4;
        return {
          name,
          url,
          agencyname
        };
      });
    }
    if (metadata.source) {
      return [{
        agencyname: metadata.agencyname || metadata.source,
        // show URL if source is missing a name
        name: metadata.sourceName || metadata.sourceURL || '',
        url: metadata.sourceURL
      }];
    }
    return [];
  }).concat(customSources).uniqBy(source => source.url).groupBy(source => source.agencyname).map((sources, agencyname) => ({
    agencyname,
    sources
  })).value();
  return {
    sources,
    summary: `${sources.map(_ref5 => {
      let {
        agencyname
      } = _ref5;
      return agencyname;
    }).join('; ')}.`
  };
};
exports.useSources = useSources;
exports.useSources.propTypes = {
  data: (0, prop_types_1.arrayOf)(types_1.sourcesDataType).isRequired,
  chartSources: (0, prop_types_1.arrayOf)(types_1.sourceType)
};
const Sources = _ref6 => {
  var _sources$, _sources$$sources;
  let {
    sources,
    summary = '',
    style = {
      fontSize: 14,
      lineHeight: 1.5,
      marginBottom: '0.5em'
    }
  } = _ref6;
  const [collapsed, setCollapsed] = (0, react_1.useState)(true);
  function getSubUrl(_ref7) {
    let {
      url,
      name,
      lastupdated
    } = _ref7;
    return react_1.default.createElement("div", {
      className: styles_module_css_1.default['long-entry'],
      key: url
    }, react_1.default.createElement("a", {
      className: styles_module_css_1.default['long-link'],
      href: url,
      target: "_blank",
      rel: "noreferrer"
    }, react_1.default.createElement("span", {
      className: styles_module_css_1.default['long-link-text']
    }, name), react_1.default.createElement("div", {
      className: styles_module_css_1.default['external-icon']
    })), react_1.default.createElement("span", {
      className: styles_module_css_1.default['long-updated']
    }, lastupdated && `(updated ${lastupdated})`));
  }
  function getSourceInfo(_ref8) {
    let {
      agencyname,
      sources
    } = _ref8;
    const outputLinks = sources.map(subSource => getSubUrl(subSource));
    if (!outputLinks) {
      return null;
    }
    return react_1.default.createElement("div", {
      className: styles_module_css_1.default['source-long'],
      key: agencyname
    }, react_1.default.createElement("div", {
      className: styles_module_css_1.default['long-title']
    }, agencyname), outputLinks);
  }
  function trimPreview(previewString) {
    if (previewString.length > 50) {
      return `${previewString.substr(0, 50)}...`;
    }
    return previewString;
  }
  if (sources.length === 0) {
    return react_1.default.createElement("div", {
      className: `${styles_module_css_1.default['text-expander']}`,
      style: style
    }, react_1.default.createElement("div", {
      className: styles_module_css_1.default['text-ex-title']
    }, "No additional source information"));
  }
  const sourceLinks = sources.map(source => getSourceInfo(source)).filter(i => i !== null);
  const isSingleSource = sources.length === 1 && ((_sources$ = sources[0]) === null || _sources$ === void 0 ? void 0 : (_sources$$sources = _sources$.sources) === null || _sources$$sources === void 0 ? void 0 : _sources$$sources.length) === 1;
  if (isSingleSource) {
    var _sources$2, _sources$2$sources$;
    return react_1.default.createElement("div", {
      className: `${styles_module_css_1.default['text-expander']} sources`,
      style: style
    }, react_1.default.createElement("div", {
      className: styles_module_css_1.default['text-ex-title']
    }, "Source:"), react_1.default.createElement("div", {
      className: styles_module_css_1.default['long-entry']
    }, react_1.default.createElement("a", {
      className: styles_module_css_1.default['long-link'],
      href: ((_sources$2 = sources[0]) === null || _sources$2 === void 0 ? void 0 : (_sources$2$sources$ = _sources$2.sources[0]) === null || _sources$2$sources$ === void 0 ? void 0 : _sources$2$sources$.url) ?? 'https://usafacts.org'
    }, react_1.default.createElement("span", {
      className: styles_module_css_1.default['long-link-text']
    }, trimPreview(summary)), react_1.default.createElement("div", {
      className: styles_module_css_1.default['external-icon']
    }))));
  }
  return react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['text-expander']} sources`,
    style: style
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-title']
  }, "Sources:"), collapsed ? react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-summary']
  }, react_1.default.createElement("span", {
    className: styles_module_css_1.default['summary-content']
  }, trimPreview(summary)), react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-more'],
    role: "button",
    tabIndex: 0,
    onKeyDown: event => {
      (0, utilities_1.handleKeyboardCommand)(event, () => {
        setCollapsed(false);
      });
    },
    onClick: () => setCollapsed(false)
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['more-text']
  }, "see more"), react_1.default.createElement("div", {
    className: styles_module_css_1.default.arrow
  }))) : react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-expander']
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-content']
  }, sourceLinks), react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-less'],
    role: "button",
    tabIndex: 0,
    onKeyDown: event => {
      (0, utilities_1.handleKeyboardCommand)(event, () => {
        setCollapsed(true);
      });
    },
    onClick: () => setCollapsed(true)
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['less-text']
  }, "see less"), react_1.default.createElement("div", {
    className: styles_module_css_1.default.arrow
  }))));
};
Sources.propTypes = {
  /**
   * Array of source sets, each with an agencyname and sources with names and urls.
   */
  sources: (0, prop_types_1.arrayOf)(types_1.sourcesType).isRequired,
  /**
   * Summary to be shown when sources are collapsed.
   */
  summary: prop_types_1.string,
  /**
   * Style for the container.
   */
  style: react_style_proptype_1.default
};
exports.default = Sources;